import React from 'react';
import RenderHeader from './RenderHeader';

const ReturnHeader = () => {
  return <RenderHeader />;
};

export default ReturnHeader;
